import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation, gql } from '@apollo/client';
import ProductForm from '../components/ProductForm';
import { toast } from 'react-hot-toast';

const CREATE_PRODUCT = gql`
  mutation CreateProduct($input: CreateProductInput!) {
    createProduct(createProductInput: $input) {
      id
      title
      description
      imageUrl
      basePrice
      serviceTypeId
      variations {
        id
        name
        price
      }
      isActive
      availableFromMonth
      availableFromDay
      availableToMonth
      availableToDay
      isCurrentlyAvailable
    }
  }
`;

export default function CreateProduct() {
  const navigate = useNavigate();
  const [createProduct, { loading }] = useMutation(CREATE_PRODUCT);
  const [error, setError] = useState(null);

  const handleSubmit = async (data) => {
    try {
      setError(null);
      
      // Remove id field from variations when creating a new product
      const variations = data.variations?.map(({ id, ...variation }) => variation);

      await createProduct({
        variables: {
          input: {
            ...data,
            availableFromMonth: data.availableFromMonth || null,
            availableFromDay: data.availableFromDay || null,
            availableToMonth: data.availableToMonth || null,
            availableToDay: data.availableToDay || null,
            serviceTypeId: data.serviceTypeId || null,
            variations
          }
        }
      });

      toast.success('Product created successfully');
      navigate('/dashboard/products');
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'An error occurred while creating the product';
      setError(errorMessage);
      toast.error(errorMessage);
    }
  };

  return (
    <>
      {error && (
        <div className="mb-4 p-4 bg-red-50 border border-red-200 text-red-600 rounded-lg">
          {error}
        </div>
      )}
      <ProductForm onSubmit={handleSubmit} isLoading={loading} />
    </>
  );
} 